import React from 'react';
import HomepageMain from './components/HomepageMain';
import './App.css';

function App() {
    return (
        <div className="App">
            <HomepageMain />
        </div>
    );
}

export default App;
